const MS_IN_DAY = 24 * 60 * 60 * 1000;

const normalizeDateInput = (value) => {
    if (!value && value !== 0) {
        return null;
    }
    if (value instanceof Date) {
        return Number.isNaN(value.getTime()) ? null : value;
    }
    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
};

const isSameDay = (a, b) => (
    a.getFullYear() === b.getFullYear()
    && a.getMonth() === b.getMonth()
    && a.getDate() === b.getDate()
);

export const formatConversationTimestamp = (dateInput, { now, locale } = {}) => {
    const date = normalizeDateInput(dateInput);
    if (!date) {
        return "";
    }
    const reference = normalizeDateInput(now) || new Date();
    const resolvedLocale = locale || undefined;

    if (isSameDay(date, reference)) {
        return date.toLocaleTimeString(resolvedLocale, { hour: "2-digit", minute: "2-digit" });
    }

    const diffMs = reference.getTime() - date.getTime();
    if (Number.isFinite(diffMs) && diffMs >= 0 && diffMs < 7 * MS_IN_DAY) {
        return date.toLocaleDateString(resolvedLocale, { weekday: "short" });
    }

    return date.toLocaleDateString(resolvedLocale, { month: "short", day: "numeric" });
};

export default formatConversationTimestamp;
